import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/**
 * Detect the brand from the hostname at runtime.
 * This allows a single build to report the correct brand to Sentry
 * without needing separate builds per brand.
 */
function detectBrand(): string {
  const hostname = window.location.hostname;
  if (hostname.includes('hotelis')) return 'hotelis';
  if (hostname.includes('bejoo')) return 'bejoo';
  if (hostname.includes('flexsis')) return 'flexsis';
  if (hostname.includes('medicalis')) return 'medicalis';
  return 'jobrocks';
}

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.sentryEnvironment || (environment.production ? 'production' : 'local'),
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: [environment.url, /^\//],
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Disable performance transaction sampling for now — focus on error tracking only.
    // The BrowserTracing integration still provides route context on errors.
    tracesSampleRate: 0,
    maxBreadcrumbs: 50,
    replaysSessionSampleRate: environment.production ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,
    initialScope: {
      tags: { brand: detectBrand() },
    },
  });

  // Set user context from localStorage if a user is already logged in
  try {
    const stored = localStorage.getItem('currentUser');
    if (stored) {
      const currentUser = JSON.parse(stored);
      if (currentUser) {
        Sentry.setUser({
          id: currentUser.id,
          email: currentUser.email,
          api_token: currentUser.api_token,
        });
      }
    }
  } catch (e) {
    // ignore parse errors on startup
  }
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
